import * as React from 'react';

import {setBodyId} from '../../../dom';
import {PageContainer, PageTitleBar} from '../../../ui/layout';
import {mountSettingsSidebar} from '../../../ui/setup/mount-settings-sidebar';
import {SetupPage} from '../../../ui/setup/setup-page';

type Props = {
    search: string;
};
/**
 * Wrapper for the sender addresses page that allows it to render as a complete
 * page outside of the setup context. We use this for the version in the marketing tab
 */
export function LeadOutcomesPageStandalone(props: Props) {
    setBodyId('list-outcome');

    return (
        <PageContainer
            noPadding={true}
            title='Outcomes'
            pageTitleBar={
                <PageTitleBar
                    title='Outcomes'
                    subheaderPrimaryText='Specify why your leads close, and dig in deeper with our losses report.'
                />
            }
        >
            <SetupPage
                pageTitle='Outcomes'
                viewUrl='/setup/outcome'
                viewParams={props.search}
                onViewRendered={mountSettingsSidebar}
            />
        </PageContainer>
    );
}
